import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

import Header from "../header/header"
import Footer from "../footer/footer";
import Faq from "../faq/faq";
import Compras from "../Compras/compras";

import PolygonUp from "../../assets/img/home/polygon 1.png"


import TumTaTiWhite from "../../assets/img/home/tutatiwhite.png"
import TumTaTiBlack from "../../assets/img/home/tumtatiblack1.png"
import Ripafactory from "../../assets/img/home/ripaFactory.png"
import MusicaeSolidariedade from "../../assets/img/home/Música e solidariedade (1).png"



import Logo from "../../assets/img/home/logo.png"



import "./home.css";

import HomeCerterImg from "../../assets/img/home/home_center_img.png"
import Midia from "../midia/midia";
import History from "../history/history";
import Galeria from "../galeria/galeria";
import Introducao from "../introducao/introducao";
import CompraRedirect from "../compra-redirect/compra-redirect";
import { useResolution  } from "../../utils/resolutionControll";


export default function Home() {

    const width = useResolution ();
    const isMobile = width < 920;

    const [scrollY, setScrollY] = useState(0);

    const [scale, setScale] = useState(1);

    const targetCompra = useRef<HTMLDivElement>(null);
    const targetInstrumentos = useRef<HTMLDivElement>(null);
    const targetHistory = useRef<HTMLDivElement>(null);
    const targetMidia = useRef<HTMLDivElement>(null);

    const handleScroll = (target: "compra" | "instrumentos" | "history" | "midia") => {
        const refs = {
            compra: targetCompra,
            instrumentos: targetInstrumentos,
            history: targetHistory,
            midia: targetMidia,
        };

        refs[target]?.current?.scrollIntoView({ behavior: "smooth" });
    };
    



    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    useEffect(() => {
        const newScale = 0.6 + scrollY * 0.01;
        setScale(Math.max(0.5, Math.min(newScale, 2)));
    }, [scrollY]);

    

    return (
        <div className="relative h-[100vh]">

            <div className="fixed-section">

                <div className="logo">

                    <img src={Logo} alt="logo ripaxote" />

                </div>

                <Header onScroll={handleScroll} />
                

                <motion.img
                    src={TumTaTiWhite}
                    alt="figura de um Polígono de fundo"
                    className="tum-ta-ti-white"
                    initial={{ x: 0, y: 0 }}

                    animate={{
                        x: [100, -100, 80, -80, 50, -50, 0],
                    }}
                    transition={{ duration: 2, ease: "easeInOut" }}

                />

                <motion.img
                    src={TumTaTiBlack}
                    alt="figura de um Polígono de fundo"
                    className="tum-ta-ti-black"
                    initial={{ x: 0, y: 0 }}

                    animate={{
                         x: [-100, 100, -80, 80, -50, 50, 0],
                    }}
                    transition={{ duration: 2, ease: "easeInOut" }}

                />



                <motion.img
                    src={HomeCerterImg}
                    alt="figura de um Polígono de fundo"
                    className="figuraTocandoInstrumento"
                    initial={{ y: 0 }}

                    style={{
                        zIndex: '13'
                    }}
                />

                <motion.img
                    src={Ripafactory}
                    alt="figura de um Polígono de fundo"
                    initial={{ y: 0, x: 0 }}
                    style={{
                        bottom: '10vh',
                        position: 'absolute',
                        width: "100vw",
                        maxWidth: "500px",
                        zIndex: 12,
                    }}
                    transition={{ ease: "easeOut", duration: 3 }}
                />

                <motion.div
                    initial={{ y: 0, x: 0 }}
                    style={{
                        bottom: '5vh',
                        position: 'absolute',
                        width: "100vw",
                        maxWidth: "300px",
                        zIndex: 12,
                        textAlign: "center",
                        fontFamily: "Montagu Slab",
                        fontWeight: 300,
                        fontSize: "24px",
                        lineHeight: "120%",
                        letterSpacing: "0%",
                        color: "#000000",
                    }}
                    transition={{ ease: "easeOut", duration: 3 }}
                >
                    Música e solidariedade
                </motion.div>



                <div style={{ overflow: "hidden", position: "relative", height: "100vh", width: "100%"}}>
                    <motion.img
                        src={PolygonUp}
                        alt="figura de um Polígono de fundo"
                       
                        style={{
                            bottom: isMobile ? "-80vh" : "-50vh",
                            scale: scale,
                            position: "relative",
                            width: "100%",
                            maxWidth: "100%",
                            zIndex: 11,
                        }}
                        transition={{ ease: "easeOut", duration: 3 }}
                    />
                </div>


            </div>

            <div onClick={() => handleScroll("compra")} className="scroll-container cursor-custom" style={{ zIndex: 10 }}>
                <CompraRedirect />

            </div>

            <div className="scroll-container">
                <Introducao />
            </div>


            <div ref={targetInstrumentos} className="scroll-container">
                <Galeria innerRef={targetHistory as React.RefObject<HTMLDivElement>}/>
            </div>


            <div ref={targetMidia} className="scroll-container">
                <Midia />
            </div>
            <div ref={targetCompra} className="scroll-container">
                <Compras />
            </div>
            <div className="scroll-container">
                <Faq />
            </div>
            <div className="scroll-container">
                <Footer />
            </div>

        </div>

    );
}

export { };

